import {SEARCHMODE} from './store-locator.mjs';

/**
 * Personal info form handlers
 */
export function initPersonalInfoForm(container, {
  idPrefix = 'slocpi',
  addressCompleteKey,
  onsuccess,
  onfailure,
  buttonText = 'Click here if your address does not appear',
} = {}) {
  // 'slocpi' stands for Store LOCator Personal Info

  addressComplete.listen('ready', _ => {
    // Define the country for the control UI (not sure whether this is used here, but that's what's shown in the doc https://www.canadapost-postescanada.ca/ac/support/advanced-setup/)
    addressComplete.setCountry("CA");
    const control = new pca.Address([
      {
        element: `${idPrefix}__address`,
        field: "Label",
        mode: pca.fieldMode.DEFAULT
      },
      {
        element: `${idPrefix}__addr-Country`,
        field: "CountryIso2",
        mode: pca.fieldMode.COUNTRY
      },
      {
        element: `${idPrefix}__addr-BuildingNumber`,
        field: "BuildingNumber",
        mode: pca.fieldMode.POPULATE
      },
      {
        element: `${idPrefix}__addr-Street`,
        field: "Street",
        mode: pca.fieldMode.POPULATE
      },
      {
        element: `${idPrefix}__addr-City`,
        field: "City",
        mode: pca.fieldMode.POPULATE
      },
      {
        element: `${idPrefix}__addr-Province`,
        field: "Province",
        mode: pca.fieldMode.POPULATE
      },
      {
        element: `${idPrefix}__addr-PostalCode`,
        field: "PostalCode",
        mode: pca.fieldMode.POPULATE
      },
      {
        element: `${idPrefix}__addr-CountryIso2`,
        field: "CountryIso2",
        mode: pca.fieldMode.POPULATE
      },
    ], {
      key: addressCompleteKey,
      search: {
        // Limit the countries to search in.
        countries: ['CA'],
      },
      bar: { visible: false },
      inlineMessages: true,
      languagePreference: 'fra',
      culture: 'fr-CA',
      manualEntry: false,
      manualEntryItem: false,
    });

    // Sorry about that.
    const selectors = [
      '#topnavstorelocator__address',
      '#claimbyphone__address'
    ];

    // We have different address autocomplete fields.
    selectors.forEach( (el) => {

      const element = document.querySelector(el);
      // Exit is no element is found.
      if(typeof(element) == 'undefined' || element == null) return;
      // Add an EventListener for address not found on pca autocomplete.
      element.addEventListener('click', () => {
        // This is so bad, PCA will duplicate ids.
        const addresses = document.querySelectorAll('#address_list');

        addresses.forEach((address) => {
          const addressParent = address.parentNode;
          const button = addressParent.firstChild;
          button.classList.add('js-address-not-found-toggle', 'address-not-found-toggle', 'd-block');
          button.textContent = buttonText;
          //Add the click event to change form.
          button.addEventListener('click', (el) =>  {
            element.closest('.js-slocpanel-personalinfo').classList.add('js-sloc-active-form--find-addresses')
            addressParent.style.display = 'none';
          });
        });
      });
    });

  });

  const form = container.querySelector('.js-slocpi-form');
  const submitBtn = container.querySelector('.js-slocpi-submit');
  const topnavstorelocator = form.querySelector('#topnavstorelocator__address');

  if (topnavstorelocator) {
    topnavstorelocator.addEventListener('focusout', event => {
      if (
        !document.querySelector(`#${idPrefix}__addr-Street`).value &&
        document.querySelector('div.pcaautocomplete') !== null
      ) {
        document.querySelector(`#topnavstorelocator__address`).value = '';
      }
    });
  }

  form.addEventListener('submit', async event => {
    event.preventDefault();

    submitBtn.classList.replace('btn--chevron', 'btn--loading');
    try {
      const data = await Promutuel.mutuals.lookupByClientInfo({
        firstname   : document.querySelector(`#${idPrefix}__firstname`).value,
        lastname    : document.querySelector(`#${idPrefix}__lastname`).value,
        dateofbirth : document.querySelector(`#${idPrefix}__dateofbirth`).value,
        postalcode  : document.querySelector(`#${idPrefix}__addr-PostalCode`).value,
        streetnumber: document.querySelector(`#${idPrefix}__addr-BuildingNumber`).value,
        streetname  : document.querySelector(`#${idPrefix}__addr-Street`).value,
        province    : document.querySelector(`#${idPrefix}__addr-Province`).value,
        country     : document.querySelector(`#${idPrefix}__addr-CountryIso2`).value,
      });
      if (onsuccess) onsuccess(data, SEARCHMODE.CLIENTINFO);
    }
    catch (err) {
      if (onfailure) onfailure(err, SEARCHMODE.CLIENTINFO);
    }
    submitBtn.classList.replace('btn--loading', 'btn--chevron');
  });
}
